import React from 'react';
import './userModal.css';

const AlertModal = ({ response, onSecondClick, setShowModal, reset, data, updateData, subAccount }) => {

    window.onclick = function (event) {

        var modal = document.getElementById("myModal");
        if (event.target === modal) {
            setShowModal(false)
            reset()
        }
    }

    const onFirstClick = () => {
        setShowModal(false)
        reset()
    }

    return <div id="myModal" className="modal">
        <div className="user-modal-content">
            <div className="modal-header">
                <h3 className="section section-header">{subAccount && subAccount.name}</h3>
                <button type="button" className="btn btn-primary" onClick={() => onFirstClick()}>Close</button>
            </div>
            <div className="modal-body row section-border">
                {
                    response.map((e, i) => <div key={i} className="col-lg-6 col-sm-12">
                        <label className="small-switch">
                            <input type="checkbox" name={e.text} value={e.value} checked={data.locations.includes(Number(e.value))} onChange={c => {
                                let updatedLocations = [];
                                if (c.target.checked) {
                                    updatedLocations = [...data.locations, Number(e.value)]
                                } else {
                                    updatedLocations = data.locations.filter((item) => { return Number(e.value) !== item })
                                }
                                updateData('locations', updatedLocations);
                            }} />
                            <span className="small-slider round"></span>
                        </label>
                        <label className="small-content-check">{e.text}</label>
                    </div>)
                }
            </div>
            <div className="modal-footer">
                <div className="col-lg col-sm-12" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" onClick={() => onSecondClick()}>Add Sub Account</button>
                </div>
            </div>
        </div>

    </div>

}

export default AlertModal;